import type { CustomButtonEventPayload } from '@components/sp-custom-button';
import type { AdvancedBorderSettings } from '@components/sp-advanced-border-settings/type/advanced-border-settings.type';

import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ThemeStateService } from '@sites/site-theme/src/state';
import { ButtonMode, SpCustomButtonModule } from '@components/sp-custom-button';
import type { AdvancedRadiusSettings } from '@components/sp-advanced-radius-settings/type/sp-advanced-radius-settings.type';

@Component({
    selector: 'web-custom-button',
    templateUrl: './web-custom-button.component.html',
    styleUrls: ['./web-custom-button.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, SpCustomButtonModule],
})
export class WebCustomButtonComponent {
    private readonly themeState = inject(ThemeStateService);

    @Input() public parentBase?: any = {};
    @Input() public parentHover?: any = {};
    @Input() public buttonMode: ButtonMode = ButtonMode.light;
    @Input() public isIndependentCorners?: boolean;
    @Input() public radiusSettings?: AdvancedRadiusSettings;
    @Input() public isAdvancedRadius?: boolean;
    @Input() public advancedBorderSettings?: AdvancedBorderSettings;

    @Output() public valueChangeEvent: EventEmitter<CustomButtonEventPayload> = new EventEmitter();

    public readonly selectedThemeColors = this.themeState.selectedColors;
}
